import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

// Ogni request è scoped all'azienda attiva; l'autorizzazione è sempre verificata server-side.
api.interceptors.request.use((cfg) => {
  const cid = localStorage.getItem("dad_company_id");
  if (cid && !cfg.headers["x-company-id"]) cfg.headers["x-company-id"] = cid;
  return cfg;
});

// Refresh silenzioso del token: un 401 non deve mai interrompere un flusso (es. Scan).
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    if (error.response?.status === 401 && !cfg._retried && !cfg.url?.startsWith("/auth/")) {
      cfg._retried = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(cfg);
      } catch {}
    }
    return Promise.reject(error);
  }
);

export async function downloadFile(url, filename, config = {}) {
  const res = await api.get(url, { ...config, responseType: "blob" });
  const blobUrl = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(blobUrl);
}

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtCHF = (n) =>
  n == null ? "—" : new Intl.NumberFormat("it-CH", { style: "currency", currency: "CHF", maximumFractionDigits: 2 }).format(n);

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};

export const fmtTime = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });
  } catch {
    return "";
  }
};
